// extracted by mini-css-extract-plugin
export default {"score":"style_score__yrIpp"};